import React from 'react';
import {Box,Button,Stack,Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import ReferAndEarnGuide from '../components/ReferAndEarnGuide';
import InfluencerProgramTerms from './InfluencerProgramTerms';

export default function ReferralTermsPage() {
 return <Box sx={{maxWidth:980,mx:'auto',px:{xs:2,sm:3},pt:3,pb:'calc(92px + env(safe-area-inset-bottom))',color:'white',overflowWrap:'anywhere'}}>
  <Button component={Link} to="/refer-and-earn" sx={{mb:2,color:'#90caf9'}}>Back to Refer &amp; Earn</Button>
  <Typography component="h1" variant="h4" sx={{fontWeight:800}}>How it works</Typography>
  <Stack spacing={3} sx={{minWidth:0}}>
   <ReferAndEarnGuide/>
   <InfluencerProgramTerms/>
  </Stack>
  <Button component={Link} to="/refer-and-earn" variant="outlined" sx={{mt:3,minHeight:44,color:"#90caf9"}}>Back to Refer &amp; Earn</Button>
 </Box>;
}
